var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge mr-2",class:_vm.paymentobj.classe},[_vm._v(_vm._s(_vm.paymentobj.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }